import { MemberType } from '@/config/constant';
import { parseFen2Yuan } from '@/utils/number';
import getRandomId from '@/utils/uuid';
import checkInService from '@/api/checkIn';
import ReserveService from '@/api/reserve';
import { MainState, RentRecordInfo } from '@/redux/reducers/reservation/checkOut';
import { RoomGuestItem } from '@/redux/reducers/reservation/base.d';

export const getCheckOutInfo: (recNos: string[]) => Promise<MainState> = async (
  recNos: string[],
) => {
  const res = await checkInService.getCheckOutInfo({ recNos });

  const {
    checkOutRoomList,
    customerInfoList,
    peripheralRoomInventoryList: peripheralList,
  } = res.data;
  const rentRoomList: RentRecordInfo[] = (checkOutRoomList || []).map((item) => {
    return {
      ...item,
      overtimePrice: parseFen2Yuan(item.overtimePrice), // 实收超时房费
      overtimePriceReceivable: parseFen2Yuan(item.overtimePrice), // 实收超时房费
      indexId: getRandomId(),
    };
  });
  const guestList: RoomGuestItem[] = customerInfoList || [];
  const roomGuestList: RoomGuestItem[] = [];
  guestList.forEach((item) => {
    const itemInfo = {
      ...item,
      indexId: getRandomId(),
    };
    if (item.memberType === MemberType.HouseOwner) {
      // 房主放到第一个
      roomGuestList.unshift(itemInfo);
    } else {
      roomGuestList.push(itemInfo);
    }
  });

  // 默认归还数量为0
  const peripheralRoomInventoryList = (peripheralList || []).map((item) => {
    return {
      ...item,
      returnQty: 0,
    };
  });
  return {
    rentRoomList,
    roomGuestList,
    overtimePriceAdjustList: [],
    peripheralRoomInventoryList: peripheralRoomInventoryList || [],
  };
};

export const getReverseReasons = async () => {
  let result: any = [];
  try {
    const res = await ReserveService.getDictListByType({
      code: 'REVERSE_REASON',
    });

    result =
      (res.data?.list || []).map((item) => {
        return {
          value: item?.dictKey,
          label: item?.dictValue,
        };
      }) || [];
  } catch (_) {
    result = [];
  }
  return result;
};
